import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=50dc4828&scoped=true&lang=pug&"
import script from "./Layout.vue?vue&type=script&lang=ts&"
export * from "./Layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dc4828",
  null
  
)

export default component.exports